import { ScreenContext } from '@/contexts/ScreenContext';
import { getHostLiveDataByHostId } from '@/modules/hostLive/slice';
import { DisplayName } from '@/modules/lobby/components/DisplayName';
import { NetState } from '@/modules/lobby/components/NetState';
import { RootState } from '@/store/store';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RwdTypography } from '../RwdTypography';
import './index.scss';

type FooterProp = {
    hostId: number;
};

const LeftArea = ({ hostId }: FooterProp) => {
    const { t } = useTranslation();

    const [gameID, setGameID] = useState<string>('');
    const { CurrentResult } = useSelector((state: RootState) =>
        getHostLiveDataByHostId(state, hostId)
    );

    useEffect(() => {
        setGameID(
            CurrentResult?.GameID !== undefined
                ? CurrentResult.GameID.toString()
                : ''
        );
    }, [CurrentResult?.GameID]);

    return (
        <RwdTypography
            stepIndex={0}
            landscapeStepIndex={3}
        >{`${t('game.game_id')} ${gameID}`}</RwdTypography>
    );
};

const RightArea = () => {
    const { scaleFactor } = useContext(ScreenContext);
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                gap: `calc(8px * ${scaleFactor})`,
            }}
        >
            <DisplayName />
            <NetState includeParentheses={true} />
        </Box>
    );
};

export const Footer = ({ hostId }: FooterProp) => {
    return (
        <Grid
            className="rwd-game-footer"
            container
            justifyContent={'space-between'}
        >
            <Grid item>
                <LeftArea hostId={hostId} />
            </Grid>
            <Grid item>
                <RightArea />
            </Grid>
        </Grid>
    );
};
